import { render } from "./DynamicHtmlIframe.vue?vue&type=template&id=65c9ebb4&ts=true"
import script from "./DynamicHtmlIframe.vue?vue&type=script&lang=ts"
export * from "./DynamicHtmlIframe.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"shared/src/entidades/builder/form/infrastructure/controls/editorTemplates/prime/DynamicHtmlIframe.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "65c9ebb4"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('65c9ebb4', __exports__)) {
    api.reload('65c9ebb4', __exports__)
  }
  
  module.hot.accept("./DynamicHtmlIframe.vue?vue&type=template&id=65c9ebb4&ts=true", () => {
    api.rerender('65c9ebb4', render)
  })

}


export default __exports__